import config from '@config';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler, makeGetByIds } from './utils';

const BASE_PATHNAME = 'disciplines';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getByIds = makeGetByIds({ dataSource, url: `${BASE_PATHNAME}/getmany` });

  const getEventDisciplines = ({ eventId }) => dataSource.get(`${BASE_PATHNAME}/${eventId}`).json();

  const getEventsDisciplinesByIds = ({ ids }) => Promise.all(ids.map((id) => getEventDisciplines({ eventId: id })));

  const getChampionshipDisciplines = ({ eventId }) =>
    dataSource.get(`${BASE_PATHNAME}/championship-events/${eventId}`).json();

  const getChampionshipsDisciplinesByIds = ({ ids }) =>
    Promise.all(ids.map((id) => getChampionshipDisciplines({ eventId: id })));

  return {
    getList: getDefaultListHandler({ url: BASE_PATHNAME, dataSource }),

    getByIds,
    getEventDisciplines,
    getEventsDisciplinesByIds,
    getChampionshipDisciplines,
    getChampionshipsDisciplinesByIds,

    getEmptyList: getDefaultEmptyList,
  };
};
